<template>
<div class="card">
    <div class="card-header">Assign Position Control Number (PCN)</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="23" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>      
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Final Classification" :value="request.audit.auditFinalClassification"/>
                </b-col>

                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Final Class Option" :value="request.audit.auditFinalClassOption"/>
                </b-col>

                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Job Code" :value="request.audit.jobCode"/>
                </b-col>

                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Bargaining Unit" :value="findUnitText(request.bargainingUnit)"/>
                </b-col>
            </b-row>
            <b-row>

                <b-col cols="12" lg="3">
                    <BaseTextInput v-model="request.positionNumber" 
                        :v="$v.request.positionNumber"
                        label="Position Control Number"
                        v-on:change.native="padPositionNumber"
                        slug="pcn"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="3">
                    <BaseTextOutput label="Finance Information"/>
                </b-col>
                <b-col cols="3">
                    <BaseTextOutput label="Needs Financial Management Review?"
                                    :value="request.financeRequiresReview"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table-simple hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>SW Cost</b-th>
                                <b-th>Sub Acct</b-th>
                                <b-th>Agcy Cost 1</b-th>
                                <b-th>Agcy Cost 2</b-th>
                                <b-th>Project</b-th>
                                <b-th>Activity</b-th>
                                <b-th>Source</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in request.funding" :key="index">
                                <b-td>{{item.fundingPercent}}</b-td>
                                <b-td>{{item.fundId}}</b-td>
                                <b-td>{{item.divisionId}}</b-td>
                                <b-td>{{item.appropriationId}}</b-td>
                                <b-td>{{item.swCost}}</b-td>
                                <b-td>{{item.subAccount}}</b-td>
                                <b-td>{{item.agcyCost1}}</b-td>
                                <b-td>{{item.agcyCost2}}</b-td>
                                <b-td>{{item.project}}</b-td>
                                <b-td>{{item.activity}}</b-td>
                                <b-td>{{item.sourceType}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
            
            <b-row>                
                <b-col cols="12">
                    <b-button type="submit" variant="primary">Complete</b-button>
                    <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, decimal, numeric, minValue, maxValue, requiredUnless } from 'vuelidate/lib/validators'
import _ from "lodash"
import { commonOptions } from '@/mixins/commonOptions.js'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList
    },

    mixins: [
       commonOptions
    ], 
    
    props: {
        request: Object
    },
    
    data() {
        return { 
            saveOnly: false,
            checklistComplete: false,
        }
    },

     validations() {
        return {
            checklistComplete: { checked: value => value === true },
            request: { 
                positionNumber: { required,
                                  maxLength: maxLength(8) 
                                },
            }
        }
     },

    computed: { },
    created() { },
    
    methods: {    
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        padPositionNumber() {
            this.request.positionNumber = String(this.request.positionNumber).padStart(8, '0')
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                pcn: this.request.positionNumber,
                complete: !this.saveOnly,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/pcnassign`, payload)
                  .then(response => {                       
                    this.showRootToast("HRM Request Has Been Updated with New PCN", "Success", "success")
                    this.$router.push('/home')
                  })
                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },

        findUnitText(code) {
            let option = this.bargainingUnitOptions.find(b => b.value === code)
            return option != null ? option.text : ''
        }
    }   
}
</script>